<template>
  <div class="pa-6">
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Quản lý thu</div>
      <DocumentExcelExport />
    </div>
    <v-card class="pa-6 elevation-1 mb-6">
      <DocumentFilter @onFilterChanged="onFilterChanged" />
    </v-card>
    <v-card class="elevation-1">
      <DocumentTable ref="documentTable" />
    </v-card>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import DocumentFilter from './ListFilter.vue'
import DocumentTable from './ListTable.vue'
import DocumentExcelExport from './ExcelExport.vue'
export default {
  components: {DocumentFilter, DocumentTable, DocumentExcelExport},
  computed: {...mapGetters('auth', ['user'])},
  async mounted() {
    await this.fetchBanks()
    await this.countItems()
  },
  methods: {
    ...mapActions({
      fetchItems: 'transaction/fetchItems',
      countItems: 'transaction/countItems',
      fetchBanks: 'transaction/fetchBanks',
    }),
    async onFilterChanged(data) {
      this.$loading.active = true
      const params = {...data}
      await this.fetchItems({...params, _start: 0, _limit: 10, _sort: 'transactionTime:DESC'})
      await this.countItems(params)
      this.$loading.active = false
    },
  },
  async beforeDestroy() {
    await this.resetState()
  },
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
